import { Box, Typography } from '@mui/material';
import GiftIcon from '../../../assets/images/icons/gift_red.png';
import StarIcon from '../../../assets/images/icons/star_red.png';

const RewardDetailInfo = ({ point, name, detail, quantity, unit, value }) => {
  return (
    <Box sx={{ padding: '5px 16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Box
        id="point"
        sx={{
          width: '100%',
          minHeight: '65px',
          backgroundColor: 'white',
          borderRadius: '6px',
          display: 'grid',
          gridTemplateColumns: '90px 1fr',
          gap: '10px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '5px',
            paddingRight: '10px',
          }}
        >
          <Box component={'img'} src={GiftIcon} alt="Gift Icon" sx={{ width: '25px' }} />
          <Typography
            sx={{
              fontSize: '1.25rem',
              lineHeight: 1,
              fontWeight: '500',
              color: '#004B61',
              textAlign: 'center',
            }}
          >
            Reward
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Box component={'img'} src={StarIcon} alt="Star Icon" sx={{ width: '25px' }} />
          <Box sx={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Typography sx={{ fontSize: '3rem', lineHeight: 1, fontWeight: '500' }}>
              {point}
            </Typography>
            <Typography sx={{ fontSize: '2rem', lineHeight: 1, fontWeight: '500' }}>
              คะแนน
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        id="name"
        sx={{
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '6px',
          display: 'grid',
          gridTemplateColumns: '80px 1fr',
          gap: '10px',
          padding: '12px 20px',
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: '1.25rem',
              lineHeight: 1,
              fontWeight: '500',
              color: '#004B61',
              mt: 0.5,
            }}
          >
            รางวัล
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '5px' }}>
          <Typography
            sx={{ fontSize: '1.75rem', color: '#FF0000', fontWeight: '500', lineHeight: 1 }}
          >
            {name}
          </Typography>
        </Box>
      </Box>

      <Box
        id="detail"
        sx={{
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '6px',
          display: 'grid',
          gridTemplateColumns: '80px 1fr',
          gap: '10px',
          padding: '12px 20px',
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: '1.25rem',
              lineHeight: 1,
              fontWeight: '500',
              color: '#004B61',
              mt: 0.5,
            }}
          >
            รายละเอียด
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '5px' }}>
          <Typography
            sx={{
              fontSize: '1.25rem',
              color: '#FF0000',
              fontWeight: '500',
              lineHeight: 1,
              whiteSpace: 'pre-wrap',
            }}
          >
            {detail}
          </Typography>
        </Box>
      </Box>

      <Box
        id="quantity"
        sx={{
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '6px',
          display: 'grid',
          gridTemplateColumns: '80px 1fr',
          gap: '10px',
          padding: '12px 20px',
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: '1.25rem',
              lineHeight: 1,
              fontWeight: '500',
              color: '#004B61',
              mt: 0.5,
            }}
          >
            จำนวน
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '5px' }}>
          <Typography
            sx={{ fontSize: '1.5rem', color: '#FF0000', fontWeight: '500', lineHeight: 1 }}
          >
            {quantity}&nbsp;&nbsp;{unit}
          </Typography>
        </Box>
      </Box>

      <Box
        id="value"
        sx={{
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '6px',
          display: 'grid',
          gridTemplateColumns: '80px 1fr',
          gap: '10px',
          padding: '12px 20px',
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: '1.25rem',
              lineHeight: 1,
              fontWeight: '500',
              color: '#004B61',
              mt: 0.5,
            }}
          >
            มูลค่า
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '5px' }}>
          <Typography
            sx={{ fontSize: '1.75rem', color: '#FF0000', fontWeight: '500', lineHeight: 1 }}
          >
            {value} บาท
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default RewardDetailInfo;
